import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'

const LocationCloseButton = () => {
    const {uiStore: {closeHomeLocationList}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore()
    return (
        <svg 
            onMouseEnter={() => handleMouseEnter("action", "Keep Exploring")}
            onMouseLeave={handleMouseLeave}
            onClick={closeHomeLocationList} pwidth="58px" height="58px" viewBox="0 0 58 58">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Being-Copy-69" transform="translate(-1755.000000, -105.000000)">
                    <g id="Group-8" transform="translate(1755.000000, 105.000000)">
                        <g id="Group-3" fill="#FFFFFF">
                            <circle id="Oval" cx="29" cy="29" r="29"></circle>
                        </g>
                        <line x1="18.9875294" y1="18" x2="41.0543863" y2="40.0668568" id="Path-3" stroke="#000000" strokeWidth="3" strokeLinecap="round"></line>
                        <line x1="18.9875294" y1="18" x2="41.0543863" y2="40.0668568" id="Path-3" stroke="#000000" strokeWidth="3" strokeLinecap="round" transform="translate(30.020958, 29.033428) scale(1, -1) translate(-30.020958, -29.033428) "></line>
                    </g>
                </g>
            </g>
            <style jsx>{`
                svg {
                    position: fixed; 
                    z-index: 10;
                    top: 70px;
                    right: 30px;
                    cursor: pointer;
                    width: 40px;
                }

                @media (pointer: coarse), (max-width: 769px) {
                    svg {
                        display: none;
                    }
                }
            `}</style>
        </svg>
        // <div onClick={closeHomeLocationList}>

            // <style jsx>{`
            //     div {
            //         position: fixed; 
            //         top: 100px;
            //         right: 40px;
            //         cursor: pointer;
            //     }
            // `}</style>
        // </div>
    )
}

export default LocationCloseButton